module.exports = __webpack_public_path__ + "img/claudia-cardinale2.91edaa4f.jpg";